var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { modalId: "modal-lv2", withBgClickEvent: "" },
    on: {
      close: function ($event) {
        return _vm.$emit("close")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", { staticClass: "flex justify-between items-center" }, [
              _c(
                "h5",
                {
                  staticClass:
                    "font-bold text-gray-800 divide-x divide-gray-200",
                },
                [
                  _c("span", { staticClass: "pr-3" }, [
                    _vm._v("Reject hours for " + _vm._s(_vm.name)),
                  ]),
                ]
              ),
              _c(
                "button",
                {
                  staticClass:
                    "ml-2 text-gray-400 hover:text-gray-500 focus:text-gray-500 focus:outline-none",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_c("CrossIconNew", { staticClass: "h-5 w-5" })],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "form-wrapper" },
              [
                _vm.showAlert
                  ? _c("div", { staticClass: "notifcation" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "mt-6 flex items-center p-2 mb-4 text-sm text-blue-800 border border-blue-300 rounded-lg bg-blue-50 dark:bg-gray-800 dark:text-blue-400 dark:border-blue-800",
                          attrs: { role: "alert" },
                        },
                        [
                          _c(
                            "svg",
                            {
                              staticClass: "flex-shrink-0 inline w-4 h-4 me-3",
                              attrs: {
                                "aria-hidden": "true",
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "currentColor",
                                viewBox: "0 0 20 20",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z",
                                },
                              }),
                            ]
                          ),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Info"),
                          ]),
                          _c("div", { staticClass: "ml-2 font-semibold" }, [
                            _vm._v(
                              " You are providing the same rejection reason for all resources selected. "
                            ),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _c("ValidationObserver", {
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ invalid, dirty, handleSubmit }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "my-4" },
                            [
                              _c("ValidationProvider", {
                                staticClass: "w-6/12",
                                attrs: {
                                  rules: "required",
                                  name: "Reason",
                                  vid: "reason",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ errors, failed }) {
                                        return [
                                          _c(
                                            "FormGroup",
                                            {
                                              staticClass: "rj-label",
                                              attrs: {
                                                errors: errors,
                                                title:
                                                  "Provide a rejection reason",
                                                id: "reason",
                                                name: "reason",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "custom-reason-select-style",
                                                },
                                                [
                                                  _c("multiselect", {
                                                    attrs: {
                                                      options: [
                                                        "Incomplete entries",
                                                        "Incorrect hours",
                                                        "Inconsistent start/end times",
                                                        "Time overlaps",
                                                        "Incorrect project code",
                                                        "Invalid activity codes",
                                                        "Unreported personal time",
                                                        "Exceeding approved overtime",
                                                        "Double-billing",
                                                        "Timesheet submitted after deadline",
                                                        "Other",
                                                      ],
                                                      searchable: false,
                                                      placeholder:
                                                        "Pick a Reason",
                                                    },
                                                    model: {
                                                      value: _vm.selectedReason,
                                                      callback: function ($$v) {
                                                        _vm.selectedReason = $$v
                                                      },
                                                      expression:
                                                        "selectedReason",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              failed
                                                ? _c("FormError", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "font-bold",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm.selectedReason === "Other"
                                ? _c(
                                    "FormGroup",
                                    {
                                      staticClass: "rj-label",
                                      attrs: {
                                        title: "Note",
                                        id: "note",
                                        name: "note",
                                      },
                                    },
                                    [
                                      _c("FormTextarea", {
                                        attrs: {
                                          rows: 4,
                                          name: "description",
                                          placeholder: "Write your note here.",
                                        },
                                        model: {
                                          value: _vm.note,
                                          callback: function ($$v) {
                                            _vm.note = $$v
                                          },
                                          expression: "note",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "flex justify-end pt-5" },
                            [
                              _c("UIButton", {
                                staticClass: "mr-3",
                                attrs: {
                                  variant: "outline",
                                  id: "cancelProject",
                                  buttonText: "Cancel",
                                  processing: _vm.loading,
                                  borderStyles: "new-btn-style",
                                  size: "sm",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("close")
                                  },
                                },
                              }),
                              _c("UIButton", {
                                attrs: {
                                  disabled: invalid || !dirty,
                                  buttonText: "Reject hours",
                                  id: "createNewProj",
                                  processing: _vm.loading,
                                  borderStyles: "new-btn-style",
                                  size: "sm",
                                  variant: "black",
                                },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.onSubmit)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }